import { getSizeData } from '../../helpers/ResizeData';

export default class FlipInfo {
  infoElement = document.getElementById('horizontal-info');

  isActive = false;

  constructor() {
    // resize
    this.initResize();
  }

  // --------------------------------------------------------------
  // Resize
  // --------------------------------------------------------------

  initResize(): void {
    window.addEventListener('resize', this.resizeUpdate.bind(this));
    // init update
    this.resizeUpdate();
    // delayed resizes - mainly because of iOS delay
    setTimeout(() => {
      this.resizeUpdate();
    }, 500);
    setTimeout(() => {
      this.resizeUpdate();
    }, 1500);
  }

  resizeUpdate(): void {
    const sizeData = getSizeData();
    this.setActive(sizeData.window.height > sizeData.window.width);
  }

  setActive(value: boolean): void {
    if (this.isActive !== value) {
      this.isActive = value;
      if (this.infoElement) {
        this.infoElement.style.display = this.isActive ? 'flex' : 'none';
      }
    }
  }
}
